export const DeclarationLineName = 'declarationLineComponent';
